module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_android_02-900-ace53e1a9d9a317d6d33e27c5c74ce29.png";